//v1.2 August 19, 2019

var app = app || {};
( function( $ ) {

   $(document).ready(
      function () {
         app.aria.init();
      }
   );

   app.aria = app.aria || {};

   //the last focused element
   app.aria.previousActiveElement = false;

   //initialization
   app.aria.init = function() {
      app.aria.tabIndex.enableVisible($('body'));
      app.aria.initKeyEvents();
      app.aria.initSkipLinks();
      app.aria.initOutlineKeyboard();
   };

   //focus on an element but don't scroll to it
   app.aria.focusNoScroll = function($ele, $container) {
      var $container = $container || $(window);
      var x = $container.scrollLeft();
      var y = $container.scrollTop();
      $ele.focus();
      $container.scrollTop(y);
      $container.scrollLeft(x);
   };

   //

   /* by default, we have no outline on focusable element, we add in outline if the user is focusing using keyboard */
   app.aria.initOutlineKeyboard = function() {

      var style_element = document.createElement('STYLE');
      var set_css = function(css_text){
         // Handle setting of <style> element contents in IE8
         !!style_element.styleSheet ? style_element.styleSheet.cssText = css_text : style_element.innerHTML = css_text;
      };
      $('head:eq(0)').append(style_element);
      $(document).on('mousedown', function(){
         set_css(':focus{outline:none;}');
      });
      $(document).on('keydown', function(){
         set_css(':focus{outline:solid;}');
      });

      

   };



   //add skip links at the beginning of the body to main content
   app.aria.initSkipLinks = function() {
      if ($('main').length) {
         var mainId = 'MainContent';
         var lang = $('html').attr('lang');
         var text = ( lang == 'fr-CA' || lang == 'fr' || lang == 'fr-FR' ) ? 'Passer au contenu principal' : 'Skip to main content';
         $('head:eq(0)').append('<style>.skip {position: absolute;top:-1000px;display: inline-block;padding:20px;color:blue;font-size: 24px;background:#fff;} .skip:focus {top:2px;left: 2px;z-index: 999;}</style>');
         $('body').prepend('<a href="#'+mainId+'" class="skip">'+text+'</a>');
         $('main:eq(0)').attr('id', mainId);
      }
   };


   //return focus to previous focused element
   app.aria.returnFocus = function() {
      if (app.aria.previousActiveElement) {
         setTimeout(function(){
            app.aria.previousActiveElement.focus();
            app.aria.previousActiveElement = false;
         },250);
      }
   };

   //remember the current focused element
   app.aria.rememberFocused = function() {
      app.aria.previousActiveElement = document.activeElement;
   };

   //handle special input from keyboard
   app.aria.initKeyEvents = function() {

      //if space or enter is pressed on button, perform a click
      $(document).on('keyup', '[role="button"]', function(e){
         if (e.keyCode === 32 || e.keyCode === 13) {
            $(this).click();
         }
      });

      //if esc key is press, trigger escape event
      $(document).on('keyup', function(e){
         if (e.keyCode === 27) {
            $(document).trigger('app:escape');
         }
      });
   };


   app.aria.tabIndex = {

      //disable all tabindex inside container
      disableAll: function($container) {
         var $container = $container || $(this);
         $container.find('[role="button"], [role="checkbox"], a, button, input, textarea, iframe').attr('tabindex','-1');
      },


      //enable tabindex that are visibile inside container
      enableVisible: function ($container) {
         var $container = $container || $(this);
         $container.find('[role="button"], [role="checkbox"], a, button, input, textarea, iframe').each(function () {
            if (app.aria.tabIndex.isHidden.call(this)) {
               $(this).attr('tabindex', '-1');
            }
            else {
               $(this).attr('tabindex', '0');
            }

         });
      },
      //check if element is hidden
      isHidden: function($ele) {
         var $ele = $ele || $(this);

         if ($ele.attr('aria-hidden') === 'true') {
            return true;
         }

         if ($ele.parents('[aria-hidden="true"]').length) {
            return true;
         }
         return false;

      }

   };

} )( jQuery );
